
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DeleteBox from "../../Base/DeleteBox.vue";
import ImageBox from "../../Base/ImageBox.vue";
import BaseTable from "../../Base/BaseTable.vue";
import { GAMETYPE_ID, InvItem, Recipes, Season } from "@/models/GameType";
import { isEqual, cloneDeep, toArray } from "lodash";
import ImageSelector from "../../Base/ImageSelector.vue";
import RecipeBox from "../../Base/RecipeBox.vue";
import RecipeBoxAdd from "../../Base/RecipeBoxAdd.vue";
import { v4 as uuid } from "uuid";

import { forIn } from "lodash";
import { DropDownItem } from "@/models/Base/GlobalData";

@Component({
  components: {
    BaseTable,
    DeleteBox,
    ImageBox,
    ImageSelector,
    RecipeBox,
    RecipeBoxAdd,
  },
})
class GameTypeInventory extends Vue {
  @Prop({ default: "EN" }) readonly languageID!: string;
  @Prop({ default: "manhunt" }) readonly gameType!: string;
  @Prop({ default: null }) readonly seasonData!: Season;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  showDetails = false;
  showSavePanel = false;
  seasonDataObject = {} as Season;
  invSlug = "";
  showImageSelectorBool = false;
  openAdd = false;

  get getTableData(): InvItem[] {
    const weaponArray: InvItem[] = [];
    forIn(this.seasonData.inv_items, (val: InvItem) => {
      weaponArray.push(val);
    });
    return weaponArray;
  }
  get getSavePanelLock(): boolean {
    if (this.isSavedOrDiscard) {
      this.showSavePanel = false;
      return false;
    } else {
      return this.showSavePanel;
    }
  }

  get getItemType(): DropDownItem[] {
    return [
      { text: "Key-Item", value: "key-item" },
      { text: "Default", value: "default" },
    ];
  }

  get getInvData(): InvItem {
    if (this.invSlug !== "") {
      if (this.seasonData.inv_items[this.invSlug] === undefined) {
        this.showDetails = false;
        return {} as InvItem;
      }
      return this.seasonData.inv_items[this.invSlug];
    }
    return {} as InvItem;
  }

  get getRecipeArray(): Recipes[] {
    var arr: Recipes[] = [];
    if (this.seasonData.inv_items[this.invSlug] !== undefined) {
      arr = toArray(this.seasonData.inv_items[this.invSlug].recipes);
    }
    return arr;
  }

  get getRecipeKeys(): string[] {
    var arr: string[] = [];
    if (this.seasonData.inv_items[this.invSlug].recipes !== undefined) {
      arr = Object.keys(this.seasonData.inv_items[this.invSlug].recipes!);
    }
    return arr;
  }

  get getImage(): string {
    return this.seasonData.inv_items[this.invSlug].img;
  }

  get getGameTypeID(): GAMETYPE_ID {
    if (this.$store.state.gameStore.gameType.length > 0)
      return this.$store.state.gameStore.gameTypeSelected;
    return GAMETYPE_ID.MANHUNT;
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.getGameTypeID +
      "/seasons/" +
      this.seasonData.slug +
      "/img/inventory/"
    );
  }

  get showDeleteButton(): boolean {
    if (
      this.getInvData.slug === "wit_q" ||
      this.getInvData.slug === "informant" ||
      this.getInvData.slug === "gold"
    ) {
      return false;
    }
    return true;
  }

  created(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
    if (this.gameType === "quest" && this.getInvData.type === "") {
      this.getInvData.type = "default";
    }
  }

  showImageSelector(): void {
    if (!this.isEditingLocked) {
      this.showImageSelectorBool = true;
    }
  }
  handleCloseButtonPress(): void {
    this.showImageSelectorBool = false;
  }

  returnImagePath(path: string): void {
    this.seasonData.inv_items[this.getInvData.slug].img =
      this.getImagePath + "" + path;

    this.onValueChanged();
    this.showImageSelectorBool = false;
  }

  deleteItem(slug: string): void {
    delete this.seasonData.inv_items[slug];
    delete this.seasonData.fx[slug];
    this.$store.dispatch("gameStore/updateSeasonType", this.seasonData);
    this.showDetails = false;
  }
  openDeleteBox(): void {
    this.$bvModal.show("team-modal-delete");
  }
  //Because the fxSlug might be different if the users swaps between games
  //We need to remove the show details so we don't keep an old screen up
  onRowSelected(row: InvItem): void {
    this.invSlug = row.slug;
    if (this.seasonData.inv_items[this.invSlug] === undefined) {
      this.showDetails = false;
    } else {
      this.showDetails = true;
    }
  }
  onValueChanged(): void {
    var data = {
      type: "inv",
      inv: this.getInvData,
      selectable: true,
    };
    if (!isEqual(this.seasonData, this.seasonDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", data);
  }

  @Watch("isEditingLocked")
  onIsEditingLockedChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
  clearImage(): void {
    if (!this.isEditingLocked) {
      this.seasonData.inv_items[this.getInvData.slug].img = "";
      this.onValueChanged();
    }
  }

  cancel(): void {
    this.openAdd = false;
  }
  openAddBox(): void {
    if (!this.isEditingLocked) {
      this.openAdd = true;
    }
  }

  deleteRecipeItem(data: any): void {
    if (this.getInvData.recipes !== undefined)
      this.getInvData.recipes[this.getRecipeKeys[data.index - 1]].items =
        data.items;

    this.$store.dispatch("gameStore/updateSeasonType", this.seasonData);
  }
  deleteRecipe(value: number): void {
    if (this.getInvData.recipes !== undefined) {
      delete this.getInvData.recipes[this.getRecipeKeys[value - 1]];
    }
    this.getRecipeArray.splice(value - 1, 1);

    this.$store.dispatch("gameStore/updateSeasonType", this.seasonData);
  }
  //This is always first item added
  receipeData(value: any): void {
    var recipe = {} as Recipes;
    var uid = uuid()
      .toString()
      .replace(new RegExp("-", "g"), "");
    recipe.items = {
      [value.slug.trim()]: {
        quant: value.quantity,
        name: { en: value.item.trim() },
        slug: value.slug.trim(),
      },
    };
    this.getRecipeKeys.push(uid);
    this.getRecipeArray.push(recipe);
    if (this.getInvData.recipes !== undefined)
      this.getInvData.recipes[uid] = recipe;
    else {
      this.getInvData.recipes = { [uid]: recipe };
    }
    this.$store.dispatch("gameStore/updateSeasonType", this.seasonData);
    this.openAdd = false;
  }

  //We know need to add additional items
  addAdditionalItems(value: any): void {
    try {
      this.getRecipeArray[value.index - 1].items = value.items;
      if (this.getInvData.recipes !== undefined)
        this.getInvData.recipes[this.getRecipeKeys[value.index - 1]].items =
          value.items;
      this.onValueChanged();
    } catch (error) {
      console.log(error);
    }
  }
}

export default GameTypeInventory;
